export const environment = {
    production: true,
    // Uses relative path - nginx ingress routes /api/* to backend
    basePath: '/api/',
    // Sentry configuration for production
    // DSN will be injected at build time via environment variable
    sentry: {
        dsn: 'https://4c2efa0298756af9ff460433936ffe5c@sentry.hamravesh.com/9748', // Replaced at build time
        release: 'fundamental-admin-angular@0d18ddd', // Replaced at build time
        enableInDev: false,
    }
}